import { render, staticRenderFns } from "./information-list.view.vue?vue&type=template&id=317ff2a6&"
import script from "./information-list.view.vue?vue&type=script&lang=ts&"
export * from "./information-list.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports